'use es6';

import Raven from 'Raven';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
import { getMeetingSourceFromLocation } from 'MeetingsLib/utils/utils';
import { track } from 'MeetingsLib/tracking/UsageTracker';
export default (function () {
  return function (next) {
    return function (action) {
      next(action);
      var meetingSource = getMeetingSourceFromLocation();

      switch (action.type) {
        case ActionTypes.LOG_MEETING_CREATE:
          {
            // Fire google tag manager event manually on successful meeting booked
            // do not remove, marketing ops is using this event to track pqls
            try {
              // <!-- Convert Experiments conversion tracking -->
              var _conv_q = window._conv_q || [];

              _conv_q.push(['triggerConversion', '10038692']);

              var gtmMeetingBookedEvent = {
                event: 'MeetingBookedEvent',
                MeetingBookedText: 'Meeting Booked'
              };

              if (window.dataLayer && window.google_tag_manager) {
                window.dataLayer.push(gtmMeetingBookedEvent);
              }
            } catch (e) {
              Raven.captureBreadcrumb({
                message: "unable to log meeting booked via datalayer"
              });
            }

            break;
          }

        case ActionTypes.SET_EVENT_DATE:
          if (action.date) {
            track('meetingsLibSetProperty', {
              property: 'event date',
              value: action.date
            });
          }

          break;

        case ActionTypes.SET_EVENT_DATE_TIME:
          if (action.dateTime) {
            track('meetingsLibSetProperty', {
              property: 'event datetime',
              value: "" + action.dateTime
            });
          }

          break;

        case ActionTypes.SET_EVENT_DURATION:
          track('meetingsLibSetProperty', {
            property: 'event duration',
            value: "" + action.duration
          });
          break;

        case ActionTypes.SET_TIMEZONE:
          track('meetingsLibSetProperty', {
            property: 'timezone',
            value: action.timezone
          });
          break;

        case ActionTypes.TOGGLE_TROUBLESHOOT_MODE:
          track('meetingsLibTroubleshoot', {
            action: action.active ? 'enter' : 'exit'
          });
          break;

        case ActionTypes.MEETING_CANCEL_SUCCEEDED:
          track('meetingEventInteraction', {
            action: 'clicked cancel',
            source: meetingSource
          });
          break;

        case ActionTypes.MEETING_RESCHEDULE_SUCCEEDED:
          track('meetingEventInteraction', {
            action: 'clicked reschedule',
            source: meetingSource
          });
          break;

        default:
      }
    };
  };
});